/** `/dr/<slug>/…` → the slug (still URL-encoded), else null. */
export const profileSlugFromUrl = (url: string): string | null => {
  const match = /^\/dr\/([^/?#]+)/.exec(url);
  return match ? match[1] : null;
};
